import CheckSVG from "images//icons/ControlCheck.svg"
import CrossSVG from "images//icons/ControlCross.svg"
import { eases } from "library/eases"
import { fresponsive } from "library/fullyResponsive"
import styled, { css, keyframes } from "styled-components"
import colors from "styles/colors"

export default function Control() {
	return (
		<>
			<Group>
				<Circle>
					<Check src={CheckSVG} alt="" />
				</Circle>
				<Circle>
					<Check src={CheckSVG} alt="" />
				</Circle>
				<Circle>
					<Check src={CheckSVG} alt="" />
				</Circle>
				<Circle>
					<Cross src={CrossSVG} alt="" />
				</Circle>
			</Group>
			<Group>
				<Circle />
				<Circle />
				<Circle />
				<Circle />
			</Group>
		</>
	)
}

const checkSlide = keyframes`
  0% {
    ${fresponsive(css`
			translate: 0 20px;
		`)}
  }
  16% {
    ${fresponsive(css`
			translate: 0 20px;
			animation-timing-function: ${eases.cubic.out};
		`)}
  }
  21% {
    translate: 0 0;
  }
  50% {
    translate: 0 0;
  }
  100% {
    translate: 0 99vh;
  }
`

const groupSlide = keyframes`
  0% {
    translate: 0 0;
  }
  31% {
    translate: 0 0;
    animation-timing-function: ${eases.quart.inOut};
  }

  47% {
    translate: 0 -100%;
  }
  100% {
    translate: 0 -100%;
  }
`

const circleSize = keyframes`
  0% {
    animation-timing-function: ${eases.back.out};
    ${fresponsive(css`
			width: 10px;
			height: 10px;
		`)}
  }

  10% {
    ${fresponsive(css`
			width: 18px;
			height: 18px;
		`)}
  }

  50% {
    ${fresponsive(css`
			width: 18px;
			height: 18px;
		`)}
  }

  51% {
    ${fresponsive(css`
			width: 10px;
			height: 10px;
		`)}
  }

  100% {
    ${fresponsive(css`
			width: 10px;
			height: 10px;
		`)}
  }
`

const Circle = styled.div`
	border: 1px solid ${colors.blue3};
	animation: ${circleSize} 8s infinite;

	${fresponsive(css`
		border-radius: 99vw;
		display: grid;
		place-items: center;
		overflow: clip;
		width: 10px;
		height: 10px;
	`)}
`

const Group = styled.div`
	animation: ${groupSlide} 8s infinite;

	${fresponsive(css`
		width: 65px;
		height: 65px;
		display: grid;
		padding: 12.5px;
		grid-template: 18px 18px / 18px 18px;
		gap: 4px;
		place-items: center;

		&:last-child {
			${Circle} {
				animation: unset;
			}
		}
	`)}
`

const Check = styled.img`
	animation: ${checkSlide} 8s infinite;
	${fresponsive(css`
		width: 18px;
	`)}
`

const Cross = styled.img`
	animation: ${checkSlide} 8s infinite;
	${fresponsive(css`
		width: 9px;
		height: 9px;
	`)}
`
